import { styled } from '@/styled-system/jsx';
import { Text } from '@zillow/constellation-10';

export const CongratulationsText = styled(Text, {
  base: {
    fontFamily: 'heading-alt',
    color: 'blue.600',
    backgroundColor: 'white',
    paddingTop: '100',
    paddingBottom: '100',
    paddingInline: '400',
    borderRadius: 'lg',
    boxShadow: 'sm',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    md: {
      paddingTop: '3px', // Custom value - no v10 token equivalent
      paddingBottom: '3px', // Custom value - no v10 token equivalent
    },
  },
});
